import React, { PureComponent } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import axios from 'axios';
import _, { isEqual } from 'lodash';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

// Contexts
import { withTranslate, withTenant } from '../../../core/TenantProvider';
import { getConfigProperty } from '../../../core/EnvironmentConfig/EnvironmentConfig';
// Components - Atoms, Molecules, Organisms, Page
import APButton from './../../atoms/APButton';
import APHeading from './../../atoms/APHeading';
import APSection from './../../atoms/APSection';
import APAlertMessage from './../../atoms/APAlertMessage';
import APStepPanel from './APStepPanel';
import APStepTracker, { APStep } from './../../atoms/APStepTracker';
import APStepContainerStyles from './styles/APStepContainer.style';
// Files in the same folder
import { ReactComponent as LockedIcon } from './assets/icon-locked.svg';

//Redux
import { EtvOptions } from '../../../redux/modules/refer/reducer';
import { ReducerState } from '../../../redux/modules';
import { actions as DialingCodeActions } from '../../../redux/modules/dialingCode';
//Types
import {
	APStepContainerFormAccount,
	APStepContainerFormAddress,
	APStepContainerState,
	ModuleMapping,
	StepDefinition,
	StepState
} from '../../../core/types/APStepContainerTypes';
import { LocationDialingCodeTypes } from '../../../redux/modules/dialingCode/types';
import { AxiosDefaults } from '../../../core/types/GeneralTypes';
// Utils
import {
	setSelectedClientLanguages,
	setSelectedCountries,
	setSelectedIndustries
} from '../../../containers/SettingsContainer/utils/setters';
import {
	CFX,
	COUNTRY_WISE_BANK_FIELDS_MAP,
	COUNTRY_WISE_LE_CONFIG,
	DEFAULT_LANGUAGE,
	INVITE_AFFILIATE,
	ORGANIZATION__CODE_MAPPING,
	PARTNER,
	PFX
} from '../../../core/utils/Constants/Constants';
import { getReferringCompany } from '../../../core/utils/ReferringCompanyValueGetter/ReferringCompanyValueGetter';
import { CheckUSAOrCanadaAffiliate } from '../../../core/utils/CheckUSAOrCanadaAffiliate/CheckUSAOrCanadaAffiliate';
import { CheckEUAffiliate } from '../../../core/utils/checkEUAffiliate/CheckEUAffiliate';
import { GetURLDetails } from '../../../core/utils/GetURLDetails';
import ValidateDate from '../../../core/utils/ValidateDate';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { getBasicAuthToken } from '../../../core/utils/BasicAuthTokenGetter';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import {
	GetDialingCodeWithAuth
} from '../../../core/utils/GetDialingCode';
import { DialingCodeObj } from '../../../core/utils/GetDialingCode/GetDialingCode';
import { getAxiosDetails } from '../../../core/utils/GetBasicDetails/GetAxiosDetails';
import { GetDialingCodeObjectAsPerCountryCode } from '../../../core/utils/GetCountriesData';


let BASIC_AUTH_TOKEN: string;
let ORGANISATION: string;
const industry: string = "industry";
const country: string = "country";
const language: string = "language";
const personalClients: string = "personalClients";
const onlineMarketSellers: string = "onlineMarketSellers";
const corporateClients: string = "corporateClients";
const employmentStatus: string = "employmentStatus";
const industryType: string = "industryType";
const address: string = "address"
const isJoint: string = "isJoint";

BASIC_AUTH_TOKEN = getBasicAuthToken(getReferringCompany());
ORGANISATION = ORGANIZATION__CODE_MAPPING[getReferringCompany()];

interface APStepContainerProps extends WithStyles<typeof APStepContainerStyles> {
	defaults?: any,
	onChange?: Function,
	onComplete?: Function,
	onContinue?: Function,
	onGoToStep?: Function,
	steps: Array<StepDefinition>,
	title: string,
	formName?: `becomePartner` | `referClient` | `registerClient`,
	subTitle?: string,
	translate: Function,
	onBlur?: Function,
	doesCustomerAlreadyExists?: boolean,
	customerAlreadyExistsCheckInProgress?: boolean,
	legalEntity?: string,
	getServicesErrorObj: Function,
	onBack?: Function,
	settings: any,
	dropdownOption?: EtvOptions,
	getClientTypeSteps?: Function,
	updateTranslations: Function,
	getLocationDialingCode: Function,
	locationDialingCodeData: LocationDialingCodeTypes
}

class APStepContainer extends PureComponent<APStepContainerProps, APStepContainerState> {
	ausDomain = getReferringCompany() === "torfxoz";
	checkDuplicateEndPoint: string = getConfigProperty('apiEndPoint')['checkDuplicate'];
	accessToken = BASIC_AUTH_TOKEN;
	dialingCodeData: DialingCodeObj = GetDialingCodeWithAuth();

	axiosDefaults: AxiosDefaults = getAxiosDetails();

	MODULE_STEP_MAPPING: ModuleMapping = {
		'register-client': {
			stepSpecificEventLabel: {
				'1': GoogleAnalyticTags.registerClient.load.customerDetailsPageLoad,
				'2': GoogleAnalyticTags.registerClient.load.addressDetailsPageLoad,
				'3': GoogleAnalyticTags.registerClient.load.confirmation
			},
			cookieName: 'register-client',
			moduleURL: '/register_client'
		},
		'register': {
			stepSpecificEventLabel: {
				'0': GoogleAnalyticTags.registration.load.personalDetailsPageLoad,
				'1': GoogleAnalyticTags.registration.load.loginPageLoad,
				'2': GoogleAnalyticTags.registration.load.bankDetailsPageLoad,
				'3': GoogleAnalyticTags.registration.load.clientDetailsPageLoad,
				'4': GoogleAnalyticTags.registration.load.confirmationPageLoad
			},
			cookieName: 'register',
			moduleURL: '/register'
		},
		'refer': {
			stepSpecificEventLabel: {
				'1': GoogleAnalyticTags.referAClient.load.contactDetailsPageLoad,
				'2': {
					transaction: GoogleAnalyticTags.referAClient.load.transactionDetailsPageLoad,
					requirement: GoogleAnalyticTags.referAClient.load.requirementDetailsPageLoad
				},
				'3': GoogleAnalyticTags.referAClient.load.confirmationPageLoad,
			},
			cookieName: 'refer1',
			moduleURL: '/refer'
		}
	};

	MODULE_STEP_MAPPING_FOR_GA4: ModuleMapping = {
		'register-client': {
			stepSpecificEventLabel: {
				'0': GoogleAnalytics4Tags.registerClient.load.customerDetailsPageLoad,
				'1': GoogleAnalytics4Tags.registerClient.load.addressDetailsPageLoad,
				'2': GoogleAnalytics4Tags.registerClient.load.confirmation
			},
			cookieName: 'register-client',
			moduleURL: '/register_client',
			moduleName: 'register_a_client'
		},
		'register': {
			stepSpecificEventLabel: {
				'0': GoogleAnalytics4Tags.registration.load.personalDetailsPageLoad,
				'1': GoogleAnalytics4Tags.registration.load.loginPageLoad,
				'2': GoogleAnalytics4Tags.registration.load.bankDetailsPageLoad,
				'3': GoogleAnalytics4Tags.registration.load.clientDetailsPageLoad,
				'4': GoogleAnalytics4Tags.registration.load.confirmationPageLoad
			},
			cookieName: 'register',
			moduleURL: '/register',
			moduleName: 'create_an_account'
		},
		'refer': {
			stepSpecificEventLabel: {
				'1': GoogleAnalytics4Tags.referAClient.load.contactDetailsPageLoad,
				'2': {
					transaction: GoogleAnalytics4Tags.referAClient.load.transactionDetailsPageLoad,
					requirement: GoogleAnalytics4Tags.referAClient.load.requirementDetailsPageLoad
				},
				'3': GoogleAnalytics4Tags.referAClient.load.confirmationPageLoad,
			},
			cookieName: 'refer1',
			moduleURL: '/refer',
			moduleName: 'refer_a_client'
		}
	};

	state = {
		isValid: false,
		isDuplicateError: false,
		isAtLeastOneSetError: false,
		form: {
			dateOfBirth: "",
			firstName: "",
			lastName: "",
			companyName: "",
			trading_name: "",
			mobile: {
				input: "",
				select: this.dialingCodeData?.dialingCode,
				displayName: this.dialingCodeData?.displayName
			},
			phone: {
				input: "",
				select: "",
				displayName: ""
			},
			address: {
				city: "",
				country: "",
				county: "",
				line1: "",
				postcode: "",
				state: "",
				categoryOfUSAState: ""
			},
			taxNumber: "",
			account: {
				bank_account_name: "",
				payment_country: "",
				payment_currency: "",
				account_number: "",
				sort_code: "",
				bsb_number: "",
				swift_code: "",
				transit_number: "",
				aba_number: "",
				branch_code: "",
				ifsc_code: "",
				iban: "",
				cnaps_code: "",
				bank_name: "",
				bank_address: "",
				matrixFields: []
			},
			isJoint: false,
			jointDateOfBirth: "",
			jointAddress: {
				city: "",
				country: "",
				county: "",
				line1: "",
				postcode: "",
				state: "",
				categoryOfUSAState: ""
			},
			jointMobile: {
				input: '',
				select: this.dialingCodeData?.dialingCode,
				displayName: this.dialingCodeData?.displayName
			},
			personalClients: false,
			onlineMarketSellers: false,
			corporateClients: false,
			industry: "",
			country: "",
			language: "",
			businessSector: "",
			businessCategory: "",
			customerType: PFX,
			employmentStatus: "",
			industryType: "",
			isIndustryDependent: false,
			isIndustryDependentJoint: false,
			showLinkDescription: false
		},
		step: 0,
		touched: {}
	}

	constructor(props: APStepContainerProps) {
		super(props);

		this.onBack = this.onBack.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onGoToStep = this.onGoToStep.bind(this);
		this.onConfirm = this.onConfirm.bind(this);
		this.onContinue = this.onContinue.bind(this);
		this.onValidStateChange = this.onValidStateChange.bind(this);
		this.validateAddress = this.validateAddress.bind(this);
		this.getMatchingModule = this.getMatchingModule.bind(this);
		this.getStepEventLabel = this.getStepEventLabel.bind(this);
		this.getModuleNameForGA4 = this.getModuleNameForGA4.bind(this);
		this.triggerAnalytics = this.triggerAnalytics.bind(this);
	}

	getMatchingModule(url: string, step: number, mapping: ModuleMapping) {
		return Object.keys(mapping).find((module) => url.includes(mapping[module].moduleURL)) || '';
	}

	getStepEventLabel(module: string, step: number | { [keyName: string]: string }, mapping: ModuleMapping) {
		const moduleInfo = mapping[module]?.stepSpecificEventLabel || {};
		const stepKey: string = step === 2 ? this.state.form.customerType === PARTNER ? 'requirement' : 'transaction' : '';

		return moduleInfo ? moduleInfo[step as number]?.[stepKey] || moduleInfo[step as number] : '';
	}

	getModuleNameForGA4(module: string, mapping: ModuleMapping) {
		const moduleInfoGA4 = mapping[module] || {};
		return moduleInfoGA4.moduleName || '';
	}

	triggerAnalytics(step: number, currentModule: string, stepLebel: string, cookieName: string, GA4StepLabel: string, currentModuleGA4Name: string) {
		if (
			(stepLebel || GA4StepLabel) &&
			((currentModule === 'register' && step === 0 && Cookies.get('register') === undefined) ||
				(currentModule !== 'register' && step === 1 && Cookies.get(cookieName) === undefined) ||
				(Cookies.get(cookieName) === step.toString()) || (this.state.form.customerType === PARTNER && step === 2 && Cookies.get(cookieName) === '2'))
		) {
			const nextCookieStepValue = step + 1;

			stepLebel && TriggerGoogleAnalyticsTag(GoogleAnalyticTags.eventAction.load, stepLebel);

			GA4StepLabel && TriggerGoogleAnalytics4Tag(
				currentModuleGA4Name,
				GoogleAnalytics4Tags.eventAction.load,
				GA4StepLabel
			);
			Cookies.set(cookieName, nextCookieStepValue.toString());
		}

		return null;
	}

	async componentDidMount() {
		const { getLocationDialingCode, locationDialingCodeData } = this.props;

		if (locationDialingCodeData) {
			this.updateDialingCode(locationDialingCodeData);
		} else {
			getLocationDialingCode();
		}
	}

	componentDidUpdate(prevProps: any, prevState: any) {
		const { step, form } = this.state;

		//Prevents user from using Browser Buttons to navigate App.
		if (prevState.step !== step && step === 1) {
			window.history.pushState(null, document.title, window.location.href);
			window.onpopstate = () => {
				window.history.go(1);
			};
		}

		const url = window.location.href;
		const CURRENT_MODULE: string = this.getMatchingModule(url, step, this.MODULE_STEP_MAPPING);
		const CURRENT_MODULE_COOKIE_NAME: string = this.MODULE_STEP_MAPPING[CURRENT_MODULE]?.cookieName;
		const CURRENT_MODULE_STEP_EVENT_LABEL: string = this.getStepEventLabel(CURRENT_MODULE, step, this.MODULE_STEP_MAPPING);
		const CURRENT_MODULE_STEP_EVENT_LABEL_FOR_GA4: string = this.getStepEventLabel(
			CURRENT_MODULE,
			step,
			this.MODULE_STEP_MAPPING_FOR_GA4
		);
		const CURRENT_MODULE_NAME_FOR_GA4: string = this.getModuleNameForGA4(CURRENT_MODULE, this.MODULE_STEP_MAPPING_FOR_GA4);

		if (CURRENT_MODULE) {
			this.triggerAnalytics(
				step,
				CURRENT_MODULE,
				CURRENT_MODULE_STEP_EVENT_LABEL,
				CURRENT_MODULE_COOKIE_NAME,
				CURRENT_MODULE_STEP_EVENT_LABEL_FOR_GA4,
				CURRENT_MODULE_NAME_FOR_GA4
			)
		}

		const { address: { country: countryData }, taxNumber } = this.state.form;
		const prevCountry = prevState?.form?.address?.country;

		if (prevCountry && !isEqual(prevCountry, countryData)) {
			if (taxNumber.length > 0) {
				const { form, touched } = this.state;
				form['taxNumber'] = '';
				touched['taxNumber'] = false;
				this.setState({
					form,
					touched
				});
			}
		}

		if (!isEqual(prevCountry, countryData)) {
			const isUSALinkURL: boolean = CheckUSAOrCanadaAffiliate(form?.address?.country);
			const isEULinkURL: boolean = CheckEUAffiliate(form?.address?.country);
			const translationBillCountry: string = form?.address?.country;

			let translationLE: string | null = null;

			if (isUSALinkURL || isEULinkURL) {
				translationLE = COUNTRY_WISE_LE_CONFIG[form?.address?.country]?.applicableLE[0];
			}
			const userSelectedLanguage: string | null = localStorage.getItem('preferredLanguage') ?? DEFAULT_LANGUAGE;

			this.props.updateTranslations(userSelectedLanguage, translationLE, translationBillCountry)
		}

		if (prevProps.locationDialingCodeData !== this.props.locationDialingCodeData) {
			this.updateDialingCode(this.props.locationDialingCodeData);
		}
	}

	updateDialingCode(locationDialingCodeData: LocationDialingCodeTypes) {
		const { countryCode3d: countryCode } = locationDialingCodeData ?? {};

		if (countryCode) {
			const dialingCodeObj: DialingCodeObj = GetDialingCodeObjectAsPerCountryCode(countryCode);

			this.setState(prevState => ({
				form: {
					...prevState.form,
					mobile: {
						select: dialingCodeObj.dialingCode,
						displayName: dialingCodeObj.displayName,
						input: ''
					},
					country: countryCode
				}
			}));
		}
	}

	static getDerivedStateFromProps(props: APStepContainerProps, state: any) {
		if (props.defaults) {
			return {
				...state,
				form: {
					...props.defaults,
					...state.form
				}
			};
		}

		return state;
	}

	defaultAccState() {
		return {
			bank_account_name: "",
			payment_country: "",
			payment_currency: "",
			account_number: "",
			sort_code: "",
			bsb_number: "",
			swift_code: "",
			transit_number: "",
			aba_number: "",
			branch_code: "",
			ifsc_code: "",
			iban: "",
			cnaps_code: "",
			bank_name: "",
			bank_address: "",
			matrixFields: []
		}
	}

	onBack() {
		this.setState({
			...this.state,
			step: this.state.step - 1,
			isAtLeastOneSetError: false
		});

		const {
			onBack,
			steps,
			formName
		} = this.props;

		if (formName === 'registerClient' && [1, 2].includes(this.state.step)) {
			const stepTags = {
				1: GoogleAnalytics4Tags.registerClient.click.addressDetailsBackCtaClicked,
				2: GoogleAnalytics4Tags.registerClient.click.confirmationBackCtaClicked
			};

			TriggerGoogleAnalytics4Tag(
				GoogleAnalytics4Tags.registerClient.name,
				GoogleAnalytics4Tags.eventAction.click,
				stepTags[this.state.step]
			);
		}

		if (onBack) {
			onBack(this.state.step - 1, steps)
		}
	}

	onGoToStep(step: any) {

		const { onGoToStep, formName } = this.props;

		if (this.state.step === 2 && formName === 'becomePartner') {
			this.setState({
				form: {
					...this.state.form,
					account: this.defaultAccState()
				}
			})
		}

		this.setState({
			step: (typeof step === 'number') ? step : this.state.step
		});

		if (onGoToStep) {
			onGoToStep(this.state.form);
		}
	}

	onBlur(evt: any) {
		const {
			target: {
				name
			}
		} = evt;

		this.setState({
			touched: {
				...this.state.touched,
				[name]: true
			}
		}, () => {
			const {
				onBlur
			} = this.props;

			if (onBlur) {
				onBlur(this.state.form, name);
			}
		});
	}

	onChange(evt: any) {
		const {
			target: {
				checked,
				name,
				type,
				value,
				isIndustryDependent
			}
		} = evt;
		const url = window.location.href;
		let resolvedValue = type === 'checkbox' ? checked : value;

		if (url.indexOf("/refer") >= 0 && type === "radio") {
			this.props.getClientTypeSteps && this.props.getClientTypeSteps(resolvedValue);
		}

		if (type === "radio" && (value === PFX || value === CFX || value === PARTNER) && url.indexOf("/refer") >= 0) {
			let analyticsTag: string = '';
			let analyticsTagGA4: string = '';

			switch (value) {
				case PFX:
					analyticsTag = GoogleAnalyticTags.referAClient.click.individualButton;
					analyticsTagGA4 = GoogleAnalytics4Tags.referAClient.click.individualButton;
					break;
				case CFX:
					analyticsTag = GoogleAnalyticTags.referAClient.click.companyButton;
					analyticsTagGA4 = GoogleAnalytics4Tags.referAClient.click.companyButton;
					break;
				case PARTNER:
					analyticsTag = GoogleAnalyticTags.referAClient.click.partnerButton;
					analyticsTagGA4 = GoogleAnalytics4Tags.referAClient.click.partnerButton;
					break;
			}

			TriggerGoogleAnalyticsTag(
				GoogleAnalyticTags.eventAction.click,
				analyticsTag
			);

			TriggerGoogleAnalytics4Tag(
				GoogleAnalytics4Tags.referAClient.name,
				GoogleAnalytics4Tags.eventAction.click,
				analyticsTagGA4
			);

			TriggerGoogleAnalytics4Tag(
				GoogleAnalytics4Tags.referralType.name,
				GoogleAnalytics4Tags.eventAction.click,
				GoogleAnalytics4Tags.referralType.click.referralTypeValue,
				{ referral_type_value: value }
			);

			Cookies.set('refer1', '1');
		}

		if (String(name) === personalClients || String(name) === onlineMarketSellers || String(name) === corporateClients) {
			if (resolvedValue) {
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.select,
					GoogleAnalyticTags.registration.select.whichClientsService,
					{ clientService: name }
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registration.name,
					GoogleAnalytics4Tags.eventAction.select,
					GoogleAnalytics4Tags.registration.select.whichClientsService,
					{ clientService: name }
				);
			}
		}
		switch (name) {
			case industry:
				resolvedValue = setSelectedIndustries(value);
				if (value !== "")
					TriggerGoogleAnalyticsTag(
						GoogleAnalyticTags.eventAction.select,
						GoogleAnalyticTags.registration.select.whichIndustriesOperate,
						{ industries: setSelectedIndustries(value).toString().split(',').pop() }
					);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registration.name,
					GoogleAnalytics4Tags.eventAction.select,
					GoogleAnalytics4Tags.registration.select.whichIndustriesOperate,
					{ industries: setSelectedIndustries(value).toString().split(',').pop() }
				);
				break;
			case country:
				resolvedValue = setSelectedCountries(value);
				if (value !== "")
					TriggerGoogleAnalyticsTag(
						GoogleAnalyticTags.eventAction.select,
						GoogleAnalyticTags.registration.select.whichCountriesBased,
						{ clientCountries: setSelectedCountries(value).toString().split(',').pop() }
					);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registration.name,
					GoogleAnalytics4Tags.eventAction.select,
					GoogleAnalytics4Tags.registration.select.whichCountriesBased,
					{ clientCountries: setSelectedCountries(value).toString().split(',').pop() }
				);
				break;
			case language:
				resolvedValue = setSelectedClientLanguages(value);
				if (value !== "")
					console.log('GA tag - Create an account - Your_clients_which_languages_do_you_clients_speak_{');
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.select,
					GoogleAnalyticTags.registration.select.whichLanguagesSpeak,
					{ clientLanguages: setSelectedClientLanguages(value).toString().split(',').pop() }
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registration.name,
					GoogleAnalytics4Tags.eventAction.select,
					GoogleAnalytics4Tags.registration.select.whichLanguagesSpeak,
					{ clientLanguages: setSelectedClientLanguages(value).toString().split(',').pop() }
				);
				break;
			case employmentStatus:
				if (value !== "")
					console.log('GA tag - Register Client - client_details_employment_{');
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registerClient.name,
					GoogleAnalytics4Tags.eventAction.select,
					GoogleAnalytics4Tags.registerClient.select.clientDetailsEmployment,
					{ employmentStatus: value }
				);
				break;
			case industryType:
				if (value !== "")
					console.log('GA tag - Register Client - client_details_work_industry_{');
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registerClient.name,
					GoogleAnalytics4Tags.eventAction.select,
					GoogleAnalytics4Tags.registerClient.select.clientDetailsWorkIndustry,
					{ workIndustry: value }
				);
				break;
			case isJoint:
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registerClient.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.registerClient.click.addressDetailsRequiresJointAccountTicked
				);
				break;
			case address:
				if (window.location.href.indexOf('/register_client') >= 0 && value.country !== '' && value.city === '') {
					TriggerGoogleAnalytics4Tag(
						GoogleAnalytics4Tags.registerClient.name,
						GoogleAnalytics4Tags.eventAction.select,
						GoogleAnalytics4Tags.registerClient.select.address.addressDetailsCountry, { country: value.country }
					);
				}
				break;
		}

		if (Array.isArray(resolvedValue) && resolvedValue.length === 0) {
			resolvedValue = '';
		}

		if (name === 'dateOfBirth' && value !== '') {
			const hasValidDate: boolean = ValidateDate(value);
			resolvedValue = hasValidDate ? resolvedValue : '';
		}

		this.setState({
			form: {
				...this.state.form,
				[name]: resolvedValue,
				...(name === 'employmentStatus' && { isIndustryDependent: !!isIndustryDependent }),
				...(name === 'jointEmploymentStatus' && { isIndustryDependentJoint: !!isIndustryDependent }),
			},
		}, () => {
			const {
				onChange, formName
			} = this.props;

			if (this.state.form.account.payment_country !== "") {
				if (Cookies.get('accountPaymentCountry') !== this.state.form.account.payment_country) {
					TriggerGoogleAnalyticsTag(
						GoogleAnalyticTags.eventAction.select,
						GoogleAnalyticTags.registration.select.bankDetailsPaymentCountry,
						{ paymentCountry: this.state.form.account.payment_country }
					);
					TriggerGoogleAnalytics4Tag(
						GoogleAnalytics4Tags.registration.name,
						GoogleAnalytics4Tags.eventAction.select,
						GoogleAnalytics4Tags.registration.select.bankDetailsPaymentCountry,
						{ paymentCountry: this.state.form.account.payment_country }
					);
					Cookies.set("accountPaymentCountry", this.state.form.account.payment_country);
				}
			}
			if (this.state.form.account.payment_currency !== "") {
				if (Cookies.get('accountPaymentCurrency') !== this.state.form.account.payment_currency) {
					TriggerGoogleAnalyticsTag(
						GoogleAnalyticTags.eventAction.select,
						GoogleAnalyticTags.registration.select.bankDetailsPaymentCurrency,
						{ paymentCurrency: this.state.form.account.payment_currency }
					);
					TriggerGoogleAnalytics4Tag(
						GoogleAnalytics4Tags.registration.name,
						GoogleAnalytics4Tags.eventAction.select,
						GoogleAnalytics4Tags.registration.select.bankDetailsPaymentCurrency,
						{ paymentCurrency: this.state.form.account.payment_currency }
					);
					Cookies.set("accountPaymentCurrency", this.state.form.account.payment_currency);
				}
			}

			if (onChange) {
				onChange(this.state.form, name);
			}

			const form = this.state.form;
			if (this.state.step === 3 && formName === 'becomePartner') {
				(!form.personalClients && !form.onlineMarketSellers && !form.corporateClients) ?
					this.setState({ isAtLeastOneSetError: true }) :
					this.setState({ isAtLeastOneSetError: false });
			}
		});
	}

	onClick(evt: any) {
		const { translate } = this.props;
		const {
			target: {
				id,
				innerText
			}
		} = evt;

		if (id === 'link') {
			this.setState({
				form: {
					...this.state.form,
					showLinkDescription: !this.state.form.showLinkDescription
				}
			});
			if (innerText === translate('register.customer.form.why.need.this')) {
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registerClient.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.registerClient.click.whyDoWeNeedThisLinkClicked
				);
			}
		}
	}

	onConfirm() {
		const {
			onComplete,
			steps
		} = this.props;
		const url = window.location.href;
		if (onComplete) {
			onComplete(this.state.form, this.state.step, steps);
			if (url.indexOf("/register") >= 0 && this.state.step === 4) {
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.click,
					GoogleAnalyticTags.registration.click.confirmCTA
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registration.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.registration.click.confirmCTA
				);
			}
			else if (url.indexOf("/refer") >= 0 && this.state.step === 3) {
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.click,
					GoogleAnalyticTags.referAClient.click.confirmationCTA
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.referAClient.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.referAClient.click.confirmationCTA
				);
			}
			else if (url.indexOf("/register_client") >= 0 && this.state.step === 2 && Cookies.get('register-client') === '3') {
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.click,
					GoogleAnalyticTags.registerClient.click.ConfirmationCtaClicked
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.registerClient.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.registerClient.click.confirmationCtaClicked
				);
			}

		}

		window.scrollTo(0, 0);
	}

	onContinue() {

		const fields = this.state.form;
		const { formName, getServicesErrorObj, onContinue, steps } = this.props;
		const shouldDuplicateEmailTrigger: boolean = formName === 'becomePartner' || (formName === 'referClient' && fields.customerType === PARTNER)
		const checkDuplicateEmail: boolean = this.state.step === 1 && shouldDuplicateEmailTrigger;

		if (formName === 'registerClient' && [0, 1].includes(this.state.step)) {
			const stepTags = {
				0: GoogleAnalytics4Tags.registerClient.click.clientDetailsContinueCtaClicked,
				1: GoogleAnalytics4Tags.registerClient.click.addressDetailsContinueCtaClicked
			};

			TriggerGoogleAnalytics4Tag(
				GoogleAnalytics4Tags.registerClient.name,
				GoogleAnalytics4Tags.eventAction.click,
				stepTags[this.state.step]
			);
		}

		if (checkDuplicateEmail) {
			this.onValidStateChange(false);
			axios.defaults.baseURL = this.axiosDefaults.baseUrl;
			axios.defaults.headers.post = this.axiosDefaults.headers;
			axios
				.post(this.checkDuplicateEndPoint, {
					"email_address": fields['email'].trim(),
					"brand": ORGANISATION,
					"customer_type": 'affiliate'
				}, { timeout: 4000 }) // If after 2.5s continue
				.then((response) => {
					// Need to show error in UI
					if (response.data['code'] === "2009") {
						this.setState({
							isDuplicateError: true
						});
					} else {
						this.onValidStateChange(true);
					}
				})
				.catch((error) => {
					console.log("error:", error);
					this.onValidStateChange(true);
					this.setState({
						isDuplicateError: false,
						step: this.state.step + 1
					});
					getServicesErrorObj(error);
				});
		} else {
			this.setState({
				step: this.state.step + 1
			});
		}

		const trimmedFirstName = fields.firstName.trim();
		const trimmedLastName = fields.lastName.trim();
		const trimmedCompanyName = fields.companyName.trim();
		const trimmedTradingName = fields.trading_name.trim();
		const mobileNumber = fields.mobile.input && fields.mobile.input?.length > 0 ? fields.mobile.input : '';
		const phoneNumber = fields.phone.input && fields.phone.input?.length > 0 ? fields.phone.input : '';

		this.setState(state => {
			state.form.firstName = trimmedFirstName;
			state.form.lastName = trimmedLastName;
			state.form.companyName = trimmedCompanyName;
			state.form.trading_name = trimmedTradingName;
			state.form.mobile.input = mobileNumber;
			state.form.phone.input = phoneNumber;

			return state
		});
		window.scrollTo(0, 0);

		const {
			step
		} = this.state;

		if (onContinue) {
			onContinue(step, steps);
		}
	}

	onValidStateChange(valid: boolean) {
		this.setState({
			isValid: valid
		});
	}

	validateAddress(countryValue: string, line1: string, city: string, county: string, postcode: string) {
		const isValid: string | boolean | null = (
			countryValue &&
			line1.match(/^[\S\s]{2,255}$/) &&
			line1.trim().length > 0 &&
			city.match(/^[\S\s]{1,40}$/) &&
			city.trim().length > 0 &&
			county.match(/^[\S\s]{1,80}$/) &&
			county.trim().length > 0 &&
			postcode.match(/^([0-9a-zA-Z- ]{3,20})$/) &&
			postcode.trim().length > 0
		);
		return !isValid;
	}

	render() {
		const {
			classes,
			steps,
			title,
			subTitle,
			translate,
			legalEntity,
			formName,
			dropdownOption
		} = this.props;

		const {
			isReferAClientModule,
			isBecomeAPartnerModule,
			isRegisterAClient
		} = GetURLDetails();

		const { isDuplicateError, isAtLeastOneSetError, form, step } = this.state;
		const {
			isJoint: isJointAccount,
			firstName,
			lastName,
			address: {
				country: addressCountry,
				line1: addressLine1,
				city: addressCity,
				county: addressCounty,
				postcode: addressPostcode,
				categoryOfUSAState: addressCategoryOfUSAState } = {} as APStepContainerFormAddress,
			jointAddress: {
				country: jointAddressCountry,
				line1: jointAddressLine1,
				city: jointAddressCity,
				county: jointAddressCounty,
				postcode: jointAddressPostcode,
				categoryOfUSAState: jointAddressCategoryOfUSAState } = {} as APStepContainerFormAddress,
			account: {
				payment_country: accountCountry,
				payment_currency: accountCurrency,
				bank_account_name: accountName,
				bank_name: accountBankname,
				bank_address: accountBankAddress,
				matrixFields: accountMatrixFields } = {} as APStepContainerFormAccount,
			personalClients,
			onlineMarketSellers,
			corporateClients,
			customerType
		} = form || {};

		const max = steps.length - 1;
		const doesCustomerAlreadyExists = this.props?.doesCustomerAlreadyExists;
		const customerAlreadyExistsCheckInProgress = this.props?.customerAlreadyExistsCheckInProgress;

		let accountMatrixFieldsValid: boolean = true;

		const isAddressNotValid: boolean = this.validateAddress(
			addressCountry,
			addressLine1,
			addressCity,
			addressCounty,
			addressPostcode
		);

		const isJointAddressNotValid: boolean = this.validateAddress(
			jointAddressCountry,
			jointAddressLine1,
			jointAddressCity,
			jointAddressCounty,
			jointAddressPostcode
		);

		accountMatrixFields.forEach((field: any) => {
			if (form.account[field].length === 0) {
				accountMatrixFieldsValid = false;
			}
		});

		if (accountMatrixFields) {
			const validFields = COUNTRY_WISE_BANK_FIELDS_MAP[accountCountry];

			if (validFields && validFields.some((field: string) => form.account[field]) && form.account['account_number']) {
				accountMatrixFieldsValid = true;
			}
		}

		const hasServiceChecked = [personalClients, onlineMarketSellers, corporateClients];
		const firstSection = steps[step]['sections'][0];
		const isAccordion: string = (firstSection['type'] === 'accordions') ? 'stepSectionAccordion' : '';
		const prependedTitle: string = firstSection.prependedTitle;
		const prependedCopy: string = firstSection.prependedCopy;
		const prependedIcon = firstSection.prependedIcon;
		const skipStep: string = firstSection.skipStep;
		const sectionTitle: string = isReferAClientModule && step !== 0 && customerType === PARTNER ? translate("refer.client.affiliate.title") : title;
		const checkDuplicateEmail: boolean = isDuplicateError && (isBecomeAPartnerModule || isReferAClientModule) && step === 1;
		const duplicateErrorMessage: string = translate(`${(isReferAClientModule && 'refer.client.partner.') || ''}global.duplicate.error.message`);

		let defaultBtns: any;
		if (isBecomeAPartnerModule && step === 0) {
			defaultBtns = (<APButton
				children={translate('step.container.form.button.continue')}
				className={classes.stepButton}
				color="primary"
				disabled={!this.state.isValid || !firstName || !lastName || isAddressNotValid}
				variant="contained"
				onClick={this.onContinue}
			/>)

		} else if (isBecomeAPartnerModule && step === 2) {
			defaultBtns = (<APButton
				children={translate('step.container.form.button.continue')}
				className={classes.stepButton}
				color="primary"
				disabled={!this.state.isValid ||
					!accountName || accountName.length > 40 || accountName.length === 0 ||
					!accountCountry || !accountCurrency || !accountMatrixFieldsValid ||
					!accountBankname || accountBankname.length > 65 || accountBankname.length === 0 ||
					!accountBankAddress || accountBankAddress.length > 65 || accountBankAddress.length === 0}
				variant="contained"
				onClick={this.onContinue}
			/>)

		} else if (isBecomeAPartnerModule && step === 3) {
			defaultBtns = (<APButton
				children={translate('step.container.form.button.continue')}
				className={classes.stepButton}
				color="primary"
				disabled={!hasServiceChecked.includes(true) || form.industry.length === 0 || form.country.length === 0 ||
					form.language.length === 0 || form.businessSector.length === 0 || form.businessCategory.length === 0}
				variant="contained"
				onClick={this.onContinue}
			/>)

		} else {
			defaultBtns = (<APButton
				children={translate('step.container.form.button.continue')}
				className={classes.stepButton}
				color="primary"
				disabled={!this.state.isValid}
				variant="contained"
				onClick={this.onContinue}
			/>)
		}

		let preTitleHtml: any;
		if (prependedTitle || prependedCopy) {
			preTitleHtml = (<div className={classes.stepSectionCopyWrapper}>
				{prependedTitle && <APHeading variant="body1" className={classes.stepSectionHeading}>{prependedIcon && <LockedIcon />} {translate(prependedTitle)}</APHeading>}
				{prependedCopy && <APHeading variant="body1" className={classes.stepSectionBody}>{translate(prependedCopy)}</APHeading>}
			</div>)
		}

		return (
			<div className={`stepContainer ${classes.stepContainer}`}>
				<div className={`stepForm ${classes.stepForm}`}>
					<APSection className={`${isAccordion} ${classes.stepSection}`} title={sectionTitle} subTitle={subTitle}>

						{checkDuplicateEmail && (
							<APAlertMessage
								className={`errorMessage`}
								title={translate("global.duplicate.error.title")}
								message={duplicateErrorMessage}
								link={`/login`}
								linkText={translate("global.duplicate.error.link")}
								severity={"error"}
								icon={'error'}
								hideCloseIcon={true}
								showLink={!isReferAClientModule}
							/>
						)}

						{skipStep &&
							<button tabIndex={0} onClick={this.onGoToStep.bind(this, this.state.step + 1)} className={classes.stepSectionSkipLink}>{translate('global.skip.step')}</button>
						}
						{preTitleHtml}

						<APStepPanel
							definition={steps[step]}
							form={this.state.form}
							onBlur={this.onBlur}
							onChange={this.onChange}
							onClick={this.onClick}
							onGoToStep={this.onGoToStep}
							onValidStateChange={this.onValidStateChange}
							touched={this.state.touched}
							doesCustomerAlreadyExists={doesCustomerAlreadyExists}
							customerAlreadyExistsCheckInProgress={customerAlreadyExistsCheckInProgress}
							legalEntity={legalEntity}
							sectionLabelError={(isAtLeastOneSetError) ? 'Please select at least 1 service' : ''}
							addressCategoryOfUSAState={addressCategoryOfUSAState}
							jointAddressCategoryOfUSAState={jointAddressCategoryOfUSAState}
							addressCountry={addressCountry}
							jointAddressCountry={jointAddressCountry}
							dropdownOption={dropdownOption}
						/>
					</APSection>

					<div className={classes.stepButtons}>
						<div className={classes.stepButtonsLeft}>
							{step > 0 && (
								<APButton
									children={translate('step.container.form.button.back')}
									className={classes.stepButton}
									color="primary"
									variant="outlined"
									onClick={this.onBack}
								/>
							)}
							{isBecomeAPartnerModule && !isRegisterAClient && step === 0 && (
								<APButton
									children={translate('step.container.form.button.backtologin')}
									className={classes.stepButton}
									color="primary"
									variant="outlined"
									href="/login"
								/>
							)}
						</div>
						<div className={classes.stepButtonsRight}>

							{isRegisterAClient && step !== 1 && step !== max && (
								<APButton
									children={translate('step.container.form.button.continue')}
									className={classes.stepButton}
									color="primary"
									disabled={!this.state.isValid}
									variant="contained"
									onClick={this.onContinue}
								/>
							)}

							{isRegisterAClient && step === 1 && (

								!isJointAccount ? (
									<APButton
										children={translate('step.container.form.button.continue')}
										className={classes.stepButton}
										color="primary"
										disabled={!this.state.isValid || (isAddressNotValid) || addressCategoryOfUSAState === "C"}
										variant="contained"
										onClick={this.onContinue}
									/>
								) : (
									<APButton
										children={translate('step.container.form.button.continue')}
										className={classes.stepButton}
										color="primary"
										disabled={!this.state.isValid || (isAddressNotValid || isJointAddressNotValid) || (addressCategoryOfUSAState === "C" || jointAddressCategoryOfUSAState === "C")}
										variant="contained"
										onClick={this.onContinue}
									/>
								)
							)}

							{!isRegisterAClient && step !== max &&
								(defaultBtns)
							}

							{step === max && formName !== INVITE_AFFILIATE && (
								<APButton
									children={translate('step.container.form.button.confirm')}
									className={classes.stepButton}
									color="primary"
									disabled={!this.state.isValid}
									variant="contained"
									onClick={this.onConfirm}
								/>
							)}
						</div>
					</div>
					{formName === INVITE_AFFILIATE && (
						<div className={classes.stepButtonsCenter}>
							<APButton
								children={translate('invite.affiliate.form.button.label')}
								color="primary"
								disabled={!this.state.isValid}
								variant="contained"
								onClick={this.onConfirm}
							/>
						</div>
					)}
				</div>
				{
					formName !== INVITE_AFFILIATE && (
						<APStepTracker className={`stepTracker ${classes.stepTracker}`}>
							{steps.map((config, index) => {
								const label: string = translate(config.label);
								const state: StepState = (
									index < step ? 'complete' : (index === step ? 'active' : 'inactive')
								);
								let isResponsiveLabel: boolean = config.isResponsiveLabel || false;

								return (
									<APStep
										key={`step-${index}`}
										label={label}
										state={state}
										isResponsiveLabel={isResponsiveLabel}
									/>
								);
							})}
						</APStepTracker>
					)
				}
				<APHeading className={classes.mobileHeading} variant="h4">
					{sectionTitle}
				</APHeading>
			</div>
		);
	}
}

const mapStateToProps = (store: ReducerState) => ({
	affiliateDetails: store.user.affiliateDetails,
	locationDialingCodeData: store.dialingCode.locationDialingCodeData,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	getLocationDialingCode: DialingCodeActions.getLocationDialingCode,

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTenant(
	withTranslate(
		withStyles(APStepContainerStyles)(APStepContainer)
	)
));
